import ReducerRegistry from "seneca-common/utils/state/reducer-registry";

import { LearningMode, PATH_TO_STATE } from "./consts";
import reducer from "./reducers/classroom";

const reducerRegistry = ReducerRegistry.getInstance();
reducerRegistry.initialise(PATH_TO_STATE, builder => {
  builder.register(PATH_TO_STATE, reducer);
});

export { reducer, LearningMode };

export {
  getSidebarOpen,
  getLearningMode,
  getScrolledUp,
  getShowEndSessionControlBarButtons,
  getFocusedQuestionId,
  getShareTopicModalOpen,
  getCourseId,
  isSectionExpanded,
  getExpandedAssignmentId,
  isAssignmentExpanded,
  getActiveTab,
  getIsActiveTabSet,
  getAssignmentId,
  getSource,
  isAssignmentsMode,
  isWrongAnswersMode,
  isSmartLearningMode,
  isDefaultMode
} from "./selectors";

export {
  setCourseId,
  openShareTopicModal,
  closeShareTopicModal,
  quitSession
} from "./actions/meta";

export {
  expandAssignment,
  collapseAssignment,
  expandSection,
  expandSections,
  collapseSection,
  toggleSidebar,
  openSidebar,
  closeSidebar,
  closeSidebarIfOpen,
  setActiveTab
} from "./actions/sidebarUI";

export {
  showEndSessionControlBarButtons,
  hideEndSessionControlBarButtons,
  setScrolledUp,
  setScrolledDown,
  setFocusedQuestionId
} from "./actions/sessionUI";

export { setLearningMode, setLearningModeMeta } from "./actions/learningMode";

export { default as Classroom } from "./models/Classroom";

export { modeToSessionTypeMap } from "./consts";
